/**
 * Одно поле на телефон и на Telegram: переключателя в форме нет, тип контакта
 * определяем по тому, что человек ввёл. Логика вынесена из компонента, чтобы
 * её можно было переиспользовать при отправке заявки.
 */
export type ContactKind = "phone" | "telegram"

export type ParsedContact = {
  kind: ContactKind
  /** Нормализованное значение: +79991234567 или @username. Пустое, если ввод пустой. */
  value: string
  isValid: boolean
}

/** Ник могли прислать ссылкой — принимаем и её. */
const TELEGRAM_LINK = /^(?:https?:\/\/)?(?:t(?:elegram)?\.me|telegram\.dog)\/(.+)$/i

/** Правила Telegram: 5–32 символа, латиница, цифры и подчёркивание, начинается с буквы. */
const TELEGRAM_NAME = /^[a-zA-Z][a-zA-Z0-9_]{4,31}$/

const MIN_PHONE_DIGITS = 9
const MAX_PHONE_DIGITS = 15

export const parseContact = (raw: string): ParsedContact => {
  const value = (raw ?? "").trim()

  if (!value) {
    return { kind: "phone", value: "", isValid: false }
  }

  const link = value.match(TELEGRAM_LINK)
  // Собачка, ссылка или любая латинская буква — значит, это точно не номер.
  const looksLikeTelegram = value.startsWith("@") || Boolean(link) || /[a-zA-Z_]/.test(value)

  if (looksLikeTelegram) {
    const name = (link ? link[1] : value).replace(/^@/, "").trim()

    return { kind: "telegram", value: name ? `@${name}` : "", isValid: TELEGRAM_NAME.test(name) }
  }

  const digits = value.replace(/\D/g, "")

  // 8 999… и 999… — привычные записи российского номера без кода страны.
  let normalized = digits
  if (digits.length === 11 && digits.startsWith("8")) {
    normalized = `7${digits.slice(1)}`
  } else if (digits.length === 10) {
    normalized = `7${digits}`
  }

  const noRepeatingChars = !/(\d)\1{5,}/.test(normalized)
  const isValid = normalized.length >= MIN_PHONE_DIGITS && normalized.length <= MAX_PHONE_DIGITS && noRepeatingChars

  return { kind: "phone", value: normalized ? `+${normalized}` : "", isValid }
}
